import { render, staticRenderFns } from "./CommonSiteMap.vue?vue&type=template&id=21a07b62&scoped=true"
import script from "./CommonSiteMap.vue?vue&type=script&lang=js"
export * from "./CommonSiteMap.vue?vue&type=script&lang=js"
import style0 from "./CommonSiteMap.vue?vue&type=style&index=0&id=21a07b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a07b62",
  null
  
)

export default component.exports